<template>
    <div>
        <v-server-table :name="tableName" :ref="tableName" url="/hse/list-alt" :columns="columns" :options="options">

            <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                <div class="clearfix d-md-none d-block"></div>

                <div v-if="allowFilterSaving" class="float-left mr-2">
                    <user-filters ref="hseSavedFilters" assetType="Hse" :filterKey="filterKey" @saving="setUserFilterData" @show="setUserFilterData"></user-filters>
                </div>

                <div class="float-left mr-2">
                    <table-filters-2 ref="hseTableFilters" filterUrl="/hse/filters" v-bind:filters="filters" :emptyFilters="filterDefs" :filterKey="filterKey" @filtersChanged="refreshTableData" @filtersCleared="filtersCleared">
                        <template slot-scope="slotProps">
                            <div class="d-inline-block">
                                <multi-select v-model="slotProps.filters['hse_types.hse_type_id']" :btnLabel="(values) => ('MIC Types ('+values.length+')')" :selectOptions="slotProps.filterData.types" :options="{multi: true}"></multi-select>
                            </div>
                            <div class="d-inline-block">
                                <multi-select v-model="slotProps.filters['division.DivisionId']" :btnLabel="(values) => ('Divisions ('+values.length+')')"  :selectOptions="slotProps.filterData.divisions" :options="{multi: true}"></multi-select>
                            </div>
                            <div class="d-inline-block">
                                <multi-select v-model="slotProps.filters['inspection.inspection_form_id']" :btnLabel="(values) => ('Inspections ('+values.length+')')" :selectOptions="slotProps.filterData.forms" :options="{multi: true}"></multi-select>
                            </div>
                            <div class="d-inline-block">
                                <date-range-selector buttonTitle="MIC Date" v-model="slotProps.filters['hse_records.hse_date']" />
                            </div>
                            <div style="display: inline-block; width: 250px;" v-if="$root.hasPermission(['employees.view'])">
                                <employee-select :forFilters="true" :selectedValues="slotProps.filters['hse_records.employee_id']" v-on:vselected="((data) => { slotProps.filters['hse_records.employee_id'] = data || {};  })"></employee-select>
                            </div>
                        </template>
                    </table-filters-2>
                </div>

                <b-dropdown variant="outline-success" :disabled="exportingTable">
                    <template slot="button-content">
                        <template v-if="!exportingTable"><i class="fa fa-file-excel-o"></i> Export</template>
                        <template v-else><i class="fa fa-circle-o-notch fa-spin"></i> Exporting</template>
                    </template>
                    <b-dropdown-item v-on:click="exportDataTable()">Standard Export</b-dropdown-item>
                    <b-dropdown-item v-on:click="exportAdvanceMIC()" v-if="false">Running Quarterly Export</b-dropdown-item>
                    <b-dropdown-item href="#">
                        <router-link :to="`/hse/export`">
                            Participation Export
                        </router-link>
                    </b-dropdown-item>
                </b-dropdown>
            </div>

            <template  slot="id" slot-scope="props">
                <router-link v-if="props.row.hse_source === 'Inspection'" :to="`/inspections/view/${props.row.id}`" title="View" class="btn btn-sm btn-secondary">
                    View
                </router-link>
                <router-link v-else :to="`/hse/view/${props.row.id}`" title="View MIC" class="btn btn-sm btn-secondary">
                    View
                </router-link>
            </template>


            <template slot="hse_type_name" slot-scope="props">
                {{ props.row.hse_type_name }}
            </template>

            <template slot="hse_date" slot-scope="props">
                <template v-if="props.row.hse_date">{{ props.row.hse_date | moment("MM/DD/YYYY") }}</template>
            </template>

            <template slot="LastName" slot-scope="props">
                <user-name :user="props.row" />
            </template>

            <template slot="JobsiteNumber" slot-scope="props">
                {{ props.row.JobsiteNumber }}
            </template>

            <template slot="JobsiteName" slot-scope="props">
                {{ props.row.JobsiteName }}
            </template>

            <template slot="DivisionName" slot-scope="props">
                {{ props.row.division_code }} - {{ props.row.DivisionName }}
            </template>

        </v-server-table>
    </div>
</template>

<script>
    import filterExtractor from '@/helpers/TableFilterExtractor';
    import customVTColDropdown from '@/components/vue-tables-2/CustomColumnDropdown';

    export default {
        props: ['assetType', 'assetId', 'allowFilterSaving'],

        data: function() {
            return {
                exportingTable: false,
                tableName: "hseTable",
                columns: ['id', 'hse_type_name', 'hse_date', 'LastName', 'JobsiteNumber', 'JobsiteName', 'DivisionName'],

                filterKey: 'hseFilters',

                filterDefs: {
                    'hse_types.hse_type_id': [],
                    'division.DivisionId': [],
                    'hse_records.employee_id': {},
                    'hse_records.hse_date': '',
                    'inspection.inspection_form_id': [],
                },
            }
        },

        watch: {
            appliedFilter(newVal, oldVal){
                //Call the helper
                this.checkForAppliedFilter();
            },
        },

        computed: {
            filters(){
                //Check State
                if(this.$store.state.tableFilters.filters[this.filterKey])
                {
                    //Send it
                    return this.$store.state.tableFilters.filters[this.filterKey];
                }

                //Return Definition
                return JSON.parse(JSON.stringify(this.filterDefs));
            },

            appliedFilter(){
                //Send it
                return this.$store.state.appliedFilters[this.filterKey] ? this.$store.state.appliedFilters[this.filterKey] : null;
            },

            options(){
                return {
                    headings: {
                        id: 'Actions',
                        hse_type_name: 'MIC Type',
                        hse_date: 'Date',
                        LastName: 'Creator',
                        JobsiteNumber: 'Jobsite#',
                        JobsiteName: 'Jobsite Name',
                        DivisionName: 'Division',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'hse_date',
                    },
                    saveState: this.allowFilterSaving,
                    columnsDropdown: customVTColDropdown,
                    visibleColumns: (this.allowFilterSaving ? this.$root.getVisibleColumnsFromState(this.tableName) : false),

                    requestAdapter: (data) => {
                        //Set the filters
                        data.filters = filterExtractor.extractFilters(this.filters);

                        //INclude the asset
                        data.assetType = this.assetType
                        data.assetId = this.assetId

                        //Send it
                        return data;
                    },
                    uniqueKey: 'hse_id',
                };
            },
        },

        methods: {

            exportDataTable(){
                //Loading indicator
                this.exportingTable = true;

                //Build the payload
                var payload = {
                    filters: filterExtractor.extractFilters(this.filters),
                    query: (this.$refs.hseTable.getRequestParams()).query,
                    orderBy: this.$refs.hseTable.options.orderBy.column,
                    ascending: this.$refs.hseTable.options.orderBy.ascending,
                    table: 'hseTable',
                    columns: this.$refs.hseTable.columns,
                    visible_columns: this.$root.getVisibleColumnsFromState(this.tableName),
                    export: true,
                };

                //Send it
                this.$http.get('/hse/list-alt', payload)
                    .then(response => {
                        //Open the new window
                        window.open(response.data);
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.error(err.response.data, 'Failed to Export MIC List');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },

            exportAdvanceMIC(){
                //Loading indicator
                this.exportingTable = true;

                //Send it
                this.$http.post('/hse/export/advanced')
                    .then(response => {
                        //Open the new window
                        window.open(response.data);
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.error(err.response.data, 'Failed to Export Advanced MIC List');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },

            refreshTableData(filters) {
                //Set the data
                this.$refs.hseTable.setPage(1);
                this.$refs.hseTable.getData();
            },

            filtersCleared(){
                //Reset
                this.refreshTableData();

                //Reset the Columns
                this.$refs.hseTableFilters.resetColVis(this.$refs.hseTable);
            },

            setUserFilterData(){
                //Call the Helper
                this.$refs.hseSavedFilters.setFilterParams(this.$refs.hseTable);
            },

            checkForAppliedFilter(){
                //Check if
                if(!this.allowFilterSaving || !this.appliedFilter)
                {
                    return;
                }

                //Call the helper
                this.$refs.inspTableFilters.setColVis(this.$refs.hseTable);
            },
        },
    }
</script>
